import React, { useState } from 'react';
import styled, { css } from 'styled-components';
import {
  brandColours,
  fontSize,
  inputStyles,
  labelStyles,
  maxBreakpointQuery,
  minBreakpointQuery,
  sectionPaddings,
} from '../styles';
import { Button, Container, Svg, RecaptchaText } from './ui';
import { submitRecaptcha } from '../utils';
import longArrow from '../images/long-arrow.inline.svg';

const StyledCallbackForm = styled.section`
  background-color: ${brandColours.tertiary};

  ${({ isTabs, isBlogDetail }) => {
    if (isTabs || isBlogDetail) {
      return css`
        ${sectionPaddings('20px', '40px')};
      `;
    } else {
      return css`
        ${sectionPaddings()};
      `;
    }
  }}
`;

const StyledInner = styled.div`
  display: grid;
  grid-template-columns: 1fr 55px;
  gap: 20px;

  ${minBreakpointQuery.medium`
    grid-template-columns: 220px 82px 1fr;
  `}

  ${minBreakpointQuery.mlarge`
    gap: 30px;
  `}

  ${minBreakpointQuery.large`
    gap: 40px;
  `}
`;

const StyledContent = styled.div``;

const StyledHeading = styled.h2`
  ${fontSize(35)}

  ${minBreakpointQuery.mlarge`
    ${fontSize(40)}
  `}

  ${minBreakpointQuery.large`
    ${fontSize(45)}
  `}
`;

const StyledText = styled.p`
  margin-top: 15px;
  line-height: 1.5;
`;

const StyledSvg = styled(Svg)`
  align-self: end;

  ${maxBreakpointQuery.medium`
    transform: rotate(-70deg) scaleX(-1) translateX(18px) translateY(-50%);
  `}

  ${minBreakpointQuery.medium`
    align-self: center;
  `}
`;

const StyledForm = styled.form`
  display: grid;
  gap: 20px;

  ${maxBreakpointQuery.medium`
    grid-column: 1 / 3;
    margin-top: 15px;
  `}

  ${minBreakpointQuery.medium`
    margin-left: 30px;
    grid-template-columns: repeat(4, 1fr);
  `}
`;

const StyledField = styled.label`
  ${minBreakpointQuery.medium`
    grid-column: span ${({ isEmail }) => (isEmail ? '3' : '2')};
  `}
`;

const StyledLabel = styled.span`
  ${labelStyles()}
`;

const StyledInput = styled.input`
  ${inputStyles()}
`;

const StyledRecaptchaText = styled(RecaptchaText)`
  margin-top: 15px;

  ${minBreakpointQuery.medium`
    grid-column: span 4;
  `}
`;

const StyledButtonWrapper = styled.div`
  ${minBreakpointQuery.medium`
    align-self: end;
  `}
`;

const StyledButton = styled(Button)`
  width: 100%;

  ${minBreakpointQuery.medium`
    padding: 13px 28px;
  `}
`;

const CallbackForm = ({ heading, text, formType, isBlogDetail }) => {
  const [submitted, setSubmitted] = useState(false);
  const [name, setName] = useState();

  return (
    <StyledCallbackForm isBlogDetail={isBlogDetail}>
      <Container narrow={true}>
        <StyledInner>
          <StyledContent>
            <StyledHeading>{heading}</StyledHeading>
            {text && <StyledText>{text}</StyledText>}
          </StyledContent>
          <StyledSvg image={longArrow} />
          {!submitted ? (
            <StyledForm
              name={`callback${
                formType === 'Exhibition'
                  ? '-exhibition'
                  : formType === 'Modular'
                    ? '-modular'
                    : ''
              }`}
              method="POST"
              data-netlify="true"
              onSubmit={async e => {
                await submitRecaptcha(e);
                setSubmitted(true);
              }}
            >
              <input
                type="hidden"
                name="form-name"
                value={`callback${
                  formType === 'Exhibition'
                    ? '-exhibition'
                    : formType === 'Modular'
                      ? '-modular'
                      : ''
                }`}
              />
              <input
                type="hidden"
                name="subject"
                value={`Form submission from %{formName}: ${name} (${
                  typeof window !== 'undefined' ? window.location.href : ''
                })`}
              />
              <StyledField>
                <StyledLabel>Name*</StyledLabel>
                <StyledInput
                  type="text"
                  name="name"
                  required
                  onChange={e => setName(e.target.value)}
                />
              </StyledField>
              <StyledField>
                <StyledLabel>Phone number*</StyledLabel>
                <StyledInput type="tel" name="phone" required />
              </StyledField>
              <StyledField isEmail={true}>
                <StyledLabel>Email*</StyledLabel>
                <StyledInput type="email" name="email" required />
              </StyledField>
              <StyledButtonWrapper>
                <StyledButton>Submit</StyledButton>
              </StyledButtonWrapper>
              <StyledRecaptchaText />
            </StyledForm>
          ) : (
            <p>Thanks, we'll be in touch soon</p>
          )}
        </StyledInner>
      </Container>
    </StyledCallbackForm>
  );
};

export default CallbackForm;
